import { render, staticRenderFns } from "./Instrucoes.vue?vue&type=template&id=f12658f8&scoped=true&"
import script from "./Instrucoes.vue?vue&type=script&lang=js&"
export * from "./Instrucoes.vue?vue&type=script&lang=js&"
import style0 from "./Instrucoes.vue?vue&type=style&index=0&id=f12658f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12658f8",
  null
  
)

export default component.exports